import { decodeEntities } from "@wordpress/html-entities";
import { Observer } from "mobx-react-lite";
import React from 'react';
import { WP_URL } from "../../../env";
import joinClassName from "../../../utils/className.utils";
import { useProps, useStore } from "../../../utils/mobx.utils";
import { truncateString } from "../../../utils/string.utils";
import { getFormattedDate } from "../../../utils/time.utils";
// import './PostResultItem.scss';
import './PostResultItemFromBlog.scss';
// hacky: wordpress REST API v2 does not return color.
export var tagToColorMap = {
    "anxiety": "orange",
    "personal-story": "yellow",
    "podcasts": "magenta",
    "school": "median",
    "short-film": "emerald",
    "depression": "steel",
};
export var getTagColor = function (tagName) {
    var _a;
    var parsedTagName = tagName.toLowerCase().replace(" ", "-");
    return (_a = tagToColorMap[parsedTagName]) !== null && _a !== void 0 ? _a : "";
};
export var parseExcerpt = function (input, truncateUpTo) {
    if (truncateUpTo === void 0) { truncateUpTo = 120; }
    var replacedHellip = input.replace(" […]</p>", "").replace(" [&hellip;]</p>", "").replace("</p>", "");
    var truncated = replacedHellip.replace(/^<p>(.+)/gi, function (m, c) { return truncateString(c, truncateUpTo, "…", true); });
    // return sanitizeHtmlAllowMoreTags(`<p>${truncated}</p>`)
    return decodeEntities(truncated);
};
var PostResultItem = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get imgLink() {
            var _a, _b, _c;
            return (_c = (_b = (_a = p.post._embedded) === null || _a === void 0 ? void 0 : _a['wp:featuredmedia']) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.source_url;
        },
        get mediumImgLink() {
            var _a, _b, _c, _d, _e, _f, _g;
            return (_g = (_f = (_e = (_d = (_c = (_b = (_a = p.post._embedded) === null || _a === void 0 ? void 0 : _a['wp:featuredmedia']) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.media_details) === null || _d === void 0 ? void 0 : _d.sizes) === null || _e === void 0 ? void 0 : _e.medium) === null || _f === void 0 ? void 0 : _f.source_url) !== null && _g !== void 0 ? _g : "";
        },
    }); });
    return React.createElement(Observer, { children: function () {
            var _a, _b, _c;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "search-post-item__swiper-slide search-post-item" },
                    s.imgLink ?
                        React.createElement("a", { className: "search-post-item__figure", href: p.post.link },
                            React.createElement("figure", { className: "", style: { backgroundImage: "url(" + s.imgLink + ")" } })) :
                        s.mediumImgLink ?
                            React.createElement("a", { className: "search-post-item__figure", href: p.post.link },
                                React.createElement("figure", { className: "", style: { backgroundImage: "url(" + s.mediumImgLink + ")" } },
                                    React.createElement("svg", { id: "logo__logotype-turn2me", width: "73", height: "13", viewBox: "0 0 73 13", className: "nav-hamburger__open" },
                                        React.createElement("use", { xlinkHref: "#logotype-turn2me" })))) :
                            React.createElement("a", { className: "search-post-item__figure", href: p.post.link },
                                React.createElement("figure", { className: "" },
                                    React.createElement("svg", { id: "logo__logotype-turn2me", width: "73", height: "13", viewBox: "0 0 73 13", className: "nav-hamburger__open" },
                                        React.createElement("use", { xlinkHref: "#logotype-turn2me" })))),
                    React.createElement("figcaption", null,
                        React.createElement("a", { href: p.post.link },
                            React.createElement("h3", { className: "search-post-item__title" }, p.post.title.rendered ? decodeEntities(p.post.title.rendered) : p.post.slug)),
                        React.createElement("p", { className: "search-post-item__meta" }, getFormattedDate(p.post.date)),
                        React.createElement("p", { className: "search-post-item__excerpt" }, parseExcerpt((_a = p.post.excerpt) === null || _a === void 0 ? void 0 : _a.rendered)),
                        React.createElement("p", { className: "search-post-item__hashtags" }, (_c = (_b = p.post._embedded) === null || _b === void 0 ? void 0 : _b['wp:term']) === null || _c === void 0 ? void 0 : _c[1].map(function (result, index) {
                            return React.createElement("a", { className: joinClassName("search-post-item__hashtag", "SearchItemColorable", getTagColor(result.name)), key: index, href: WP_URL + "/tag/" + result.slug }, result.name.length > 15 ? decodeEntities(result.name).substring(0, 15).concat('…') : decodeEntities(result.name));
                        }))))));
        } });
};
export default PostResultItem;
